import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=1fc60b81&scoped=true&"
import script from "./QuestionList.vue?vue&type=script&lang=js&"
export * from "./QuestionList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=1fc60b81&lang=scss&scoped=true&"
import style1 from "./QuestionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc60b81",
  null
  
)

export default component.exports